module.exports = __webpack_public_path__ + "img/4e7a520.webp";